import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `#20232a`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `0.95rem 0.0875rem 0rem 0.0875rem`,
        fontSize: `0.85rem`,
        fontFamily: `'Cormorant Garamond', Georgia, serif`,
        fontWeight: 300,
        letterSpacing: `0.25em`,
      }}
      className="d-none d-lg-block"
    >
      <h1 style={{ margin: 0 }} className="text-center">
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
